import React, { useState } from 'react';

import {
  Collapse,
  Table,
  TableBody,
  TableCell,
  TableFooter,
  TableHead,
  TableRow
} from '@material-ui/core';
import TablePagination from '@material-ui/core/TablePagination';

import { LIMIT_POINTS } from '../../contrib/utils';
import { userPic } from '../../assets/images';

export interface IParsedStanding {
  firstName: string;
  lastName: string;
  rows: Array<{
    name: string;
    id: number;
    points: number;
  }>;
  img: string;
  points: number;
}

interface IProps {
  parsedStandings: IParsedStanding[];
}

export const LeaderBoard = ({ parsedStandings }: IProps) => {
  const [collapsedRow, setCollapsedRow] = useState<null | number>(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(200);

  const onClick = (index: number) => () => {
    if (collapsedRow === index) {
      return setCollapsedRow(null);
    }
    setCollapsedRow(index);
  };

  const handleChangePage = (_EVENT: any, pageNumber: number) => {
    setPage(pageNumber);
    setCollapsedRow(null);
  };

  const handleChangeRowsPerPage = (event: any) => {
    setPage(0);
    setRowsPerPage(event.target.value);
  };

  return (
    <Table className="leaderboard">
      <TableHead className="leaderboard__thead">
        <TableRow className="leaderboard-header">
          <TableCell className="leaderboard-header__cell override">Pos</TableCell>
          <TableCell className="leaderboard-header__cell override">Player</TableCell>
          <TableCell className="leaderboard-header__cell override">Points</TableCell>
        </TableRow>
      </TableHead>
      <TableBody className="leaderboard__tbody">
        {parsedStandings
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map((item: IParsedStanding, index) => [
            <TableRow
              onClick={onClick(index)}
              id={`clickableRow-${index}`}
              key={`tableRow-${index}`}
            >
              <TableCell className="position-cell override">{index + 1}</TableCell>
              <TableCell className="common-cell override">
                <div className="user-cell">
                  <img
                    src={userPic}
                    alt={`${item.firstName} ${item.lastName}`}
                    className="leader-pic"
                  />
                  <span>{`${item.firstName} ${item.lastName}`}</span>
                </div>
              </TableCell>
              <TableCell className="points-cell override">
                {item.points >= LIMIT_POINTS ? '--' : item.points}
              </TableCell>
            </TableRow>,
            <TableRow className="expandable-row" key={`hiddenTableRow-${index}`}>
              <TableCell className="inner-cell" colSpan={3}>
                <Collapse
                  className={`collapse-${index}`}
                  classes={{
                    container: 'leaderboard-collapse',
                    wrapperInner: 'leaderboard-collapse__wrapper-inner override'
                  }}
                  in={collapsedRow === index}
                  timeout="auto"
                  unmountOnExit={true}
                >
                  {collapsedRow === index
                    ? item.rows
                        .sort((rowA, rowB) => {
                          if (rowA.id > rowB.id) {
                            return 1;
                          }
                          if (rowA.id < rowB.id) {
                            return -1;
                          }
                          return 0;
                        })
                        .map((row, rowIndex) => [
                          <TableRow
                            className="leaderboard-details-row override"
                            key={`tableRow-event-${rowIndex}`}
                          >
                            <TableCell
                              className="
                            leaderboard-details-row__cell
                            leaderboard-details-row__cell--event-name
                            override
                          "
                            >
                              {row.name}
                            </TableCell>
                            <TableCell
                              align="center"
                              className="
                            leaderboard-details-row__cell
                            leaderboard-details-row__cell--event-points
                            override
                          "
                            >
                              {row.points >= LIMIT_POINTS ? '--' : row.points}
                            </TableCell>
                          </TableRow>
                        ])
                    : null}
                </Collapse>
              </TableCell>
            </TableRow>
          ])}
      </TableBody>
      <TableFooter>
        <TableRow>
          <TablePagination
            className="leaderboard-pagination override"
            classes={{
              actions: 'leaderboard-pagination__actions override',
              caption: 'leaderboard-pagination__caption override',
              select: 'leaderboard-pagination__select override'
            }}
            rowsPerPageOptions={[200, 250, 300]}
            onChangeRowsPerPage={handleChangeRowsPerPage}
            page={page}
            rowsPerPage={rowsPerPage}
            onChangePage={handleChangePage}
            count={parsedStandings.length}
          />
        </TableRow>
      </TableFooter>
    </Table>
  );
};
